module.exports = __webpack_public_path__ + "media/images/logo-1e20a6ba49929ed79bf2e3df0c28002c.png";